import React, { useEffect, useState } from "react";
import TopBanner from "../../../components/common/topbanner";
import { useNavigate, useParams } from "react-router-dom";
import AdminDataTable from "../../AdminPages/Component/Common/admin-datatable";
import { DOWNLOAD_ICON, INPUT_CSV_ICON, INPUT_PDF_ICON } from "../../../utils/app-image-contant";
import {
  getAllProduct,
} from "../../../hooks/services/api-services";
import { API_RESPONSE } from "../../../utils/app-constants";
import { downloadPdfFile, toastEmitter } from "../../../utils/utilities";
import Input from "../../../components/common/input";
import RecordNotfound from "./Common/recordNotfound";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../utils/url-constants";
import Select from "../../../components/common/select";
import { wrap } from "lodash";
import { CSVLink } from "react-csv";

const ProductPortfolio = () => {
  const { name } = useParams();
  const navigation = useNavigate();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [selectedRows, setSelectedRows] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [pending, setPending] = useState(true);
  const [totalElement, settotalElement] = useState();
  const [totalElementShortedList, settotalElementShortedList] = useState();
  const [rowData, setRowData] = useState([]);
  const [isSearch, setIsSearch] = useState(true);
  const [filterValue, setFilterValue] = useState("drug_code");
  const [filterName, setFilterName] = useState("asc");
  const [loaderbtn, setBtnLodaer] = useState(false)
  const [csvData, setCsvData] = useState([])

  const [payload, setPayload] = useState({
    pageIndex: page || 0,
    pageSize: pageSize || 10,
    searchText: "",
    orderBy: filterName || "asc",
    columnName: filterValue || "drug_code"
  });

  var currentdate = new Date();
  var datetime = + currentdate.getDate() + "/"
    + (currentdate.getMonth() + 1) + "/"
    + currentdate.getFullYear() + " @ "
    + currentdate.getHours() + ":"
    + currentdate.getMinutes() + ":"
    + currentdate.getSeconds();

  const csvheaders = [
    { label: 'Sr No', key: 'SrNo' },
    { label: 'Drug Code', key: 'drug_code' },
    { label: 'Generic Name', key: 'generic_name' },
    { label: 'Unit Size', key: 'unit_size' },
    { label: 'MRP', key: 'mrp' },
    { label: 'Group Name', key: 'group_name' },
  ];

  const downloadPdf = async () => {
    setBtnLodaer(true)
    let downloadPayload =
    {
      pageIndex: 0,
      pageSize: 1000000,
      searchText: payload?.searchText||"",  
      orderBy: "asc",
      columnName: name === "ProductviewList" ? filterValue : "drug_code"
    }

    await downloadPdfFile(
      `${API_URL?.baseURL}${API_URL?.product?.downloadpdf}`,
      "product",
      ".pdf",
      downloadPayload,
      setBtnLodaer
    );
    setBtnLodaer && setBtnLodaer(false);
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#283779",
        fontSize: "16px",
        padding: "3px",
        backgroundColor: "#EBE8FF",
        borderRadius: "15px",
      },
    },
    rows: {
      style: {
        color: "#18100F",
        fontSize: "16px",
        padding: "4px",
        boxSizing: "border-box",
        border: "1px solid #8C7CFF",
        marginTop: "10px",
        borderRadius: "15px",
      },
    },
  };



  const tblColumns = [
    {
      code: "id",
      name: "Sr.No",
      width: "90px",
      sortable: false,
      selector: (row, i) => `${row?.serialNo}`,
    },
    {
      code: "Drug Code",
      name: "Drug Code",
      width: "180px",
      sortable: false,
      selector: (row) => `${row?.drugCode}`,
    },
    {
      code: "Generic Name",
      name: "Generic Name",
      width: "380px",
      wrap: true,
      sortable: false,
      selector: (row) => `${row.genericName}`,
    },
    {
      code: "Unit Size",
      name: "Unit Size",
      width: "120px",
      sortable: false,
      selector: (row) => `${row.unitSize}`,
    },
    {
      code: "MRP(in RS.)",
      name: "MRP(in RS.)",
      width: "120px",
      sortable: false,
      selector: (row) => `${parseFloat(row.mrp).toFixed(2)}`,
    },
    {
      code: "Group Name",
      name: "Group Name",
      width: "320px",
      wrap: true,
      sortable: false,
      selector: (row) => `${row.groupName}`,
    },
  ];

  const createPayload = (columnName, orderBy) => {
    let filterData = filterValue !== "mrp_3" ? filterValue : filterValue?.split('_')[0]
    const payloadData = {
      pageIndex: page || 0,
      pageSize: pageSize || 10,
      searchText: payload?.searchText,
      columnName: columnName || filterData || "drug_code",
      orderBy: orderBy || filterName || "asc",
    };
    setPayload(payloadData);
  };


  const createPayload2 = () => {
    const isSearching = payload?.searchText?.trim() !== "";
    const payloadData = {
      pageIndex: isSearching ? 0 : page,
      pageSize: 10,
      searchText: payload?.searchText || "",
      columnName: "drug_code",
      orderBy: "asc",
    };
    setPayload(payloadData);
  };

  useEffect(() => {
    if (name === "ProductviewList") {
      createPayload();

    }
    if (name === "ProductmrpList") {
      createPayload2()
    }
  }, [page, pageSize, sortColumn, sortDirection, filterValue, filterName]);

  useEffect(() => {
    if (isSearch) {
      CreateCsvData() //Call export csv
      getAllProductList();
    }
  }, [payload]);

  useEffect(() => {
    // Clear search text and reset pagination when changing tabs
    setPayload((prevPayload) => ({
      ...prevPayload,
      searchText: "",
    }));
    setPage(0);
    setPageSize(10);
    setIsSearch(true);
    CreateCsvData() //Call export csv
    getAllProductList();
  }, [name]);

  // const handleChange = (e) => {
  //   setIsSearch(false);
  //   const { value } = e.target;
  //   setSearchText(value);
  //   setPayload((prevPayload) => ({ ...prevPayload, searchText: value }));

  //   // If search text is cleared, call the API
  //   if (value.trim() == "") {
  //     setPage(0);
  //     setPageSize(10);
  //     getAllProductList();
  //   }
  // };

  const handleChange = (e) => {
    // setIsSearch(false);
    const { value } = e.target;
    setSearchText(value);

    if (value.trim() === "") {
      setIsSearch(true);
      setPage(0);
      setPageSize(10);

      // Reset the payload state with empty search text and other defaults
      setPayload({
        pageIndex: 0,
        pageSize: 10,
        searchText: "",
        columnName: "drug_code",
        orderBy: "asc"
      });
    } else {
      setPayload((prevPayload) => ({ ...prevPayload, pageIndex: 0, pageSize: 10, searchText: value }));
    }
  };


  const handleSearch = async () => {
    // Reset page and pageSize for the search operation
    setPage(0);
    setPageSize(10);
    createPayload2()
    getAllProductList();
  };

  const getAllProductList = async () => {
    try {
      setPending(true);

      const response = await getAllProduct(payload);
      if (response?.data?.responseCode === 200) {
        settotalElement(response?.data?.responseBody?.totalElement);
        settotalElementShortedList(response?.data?.responseBody?.totalElement);
        let obj = response?.data?.responseBody?.newProductResponsesList;
        setProductsList(obj);
        setPending(false);
      } else if (response?.data?.responseCode === 404) {
        setProductsList([]);
        setRowData([]);
        setPending(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setPending(false);
    }
  };


  const CreateCsvData = async () => {
    let elementdata = [];
    let csvPayload = {
      pageIndex: 0,
      pageSize: 1000000,
      searchText: searchText||"",
      orderBy: "asc",
      columnName: filterValue
    }
    const response = await getAllProduct(csvPayload);
    let obj = response?.data?.responseBody?.newProductResponsesList;
    for (let index = 0; index < obj?.length; index++) {
      const nObj = { SrNo: index + 1, drug_code: obj[index]?.drugCode, generic_name: obj[index]?.genericName, unit_size: obj[index]?.unitSize, mrp: obj[index]?.mrp, group_name: obj[index]?.groupName }
      elementdata.push(nObj);
    }
    setCsvData([...elementdata]);
  }

  const secondText = () => {
    switch (name) {
      case "ProductmrpList":
        return t("productmrplist");
      case "ProductviewList":
        return t("productviewlist");
      default:
        return '';
    }
  };

  useEffect(() => {
    // Clear search text when changing tabs
    setPayload((prevPayload) => ({
      ...prevPayload,
      searchText: "",
      // columnName: "id"
    }));
    setIsSearch(true); // Ensure search is triggered
    getAllProductList();
  }, [name]);

  const handleViewListSelect = (event) => {
    let selectedValue = event.target.value;
    let columnName = "";
    let orderBy = "";
    if (name === "ProductviewList") {
      if (selectedValue === "mrp") {
        orderBy = "asc"
      }
      else if (selectedValue === "mrp_3") {
        orderBy = "desc"
      }
      else {
        orderBy = "asc";
      }
    }
    setFilterValue(selectedValue);
    setFilterName(orderBy);
    createPayload(columnName, orderBy);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="jana_productportfolio_sec jana_news_sec">
        <TopBanner
          text={t("productportfolio")}
          homeText={t("Home")}
          firstText={t("productportfolio")}
          secondaryText={secondText()}
        />

        <div className="container">
          <div className="jana_productportfolio_tabsec pt-4 pb-2">
            <ul
              className="jana_productportfolio_tabs nav nav-pills mx-1 mb-4 justify-content-between row"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item col-md-6 text-start" role="presentation">
                <button
                  id="headingColor" class={`nav-link ${name === "ProductmrpList" ? "active" : ""
                    }`}
                  type="button"
                  onClick={() =>
                    navigation(
                      `${process.env.PUBLIC_URL
                      }/productportfolio/${"ProductmrpList"}`
                    )
                  }
                >
                  {t("productmrplist")}
                </button>
              </li>
              <li className="nav-item col-md-6" role="presentation">
                <button
                  id="headingColor" class={`nav-link ${name === "ProductviewList" ? "active" : ""
                    }`}
                  type="button"
                  onClick={() =>
                    navigation(
                      `${process.env.PUBLIC_URL
                      }/productportfolio/${"ProductviewList"}`
                    )
                  }
                >
                  {t("productviewlist")}
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              {name === "ProductmrpList" && (
                <>
                  <div className="row tabledropdown tableinfo">
                    <div className="col-sm-12 col-md-12 col-lg-6 mb-3">
                      <Input
                        typeName="text"
                        mandatory={false}
                        placeholder="Enter Drug Code / Product Name"
                        lableName="Search by Drug Code / Product Name / Unit Size / MRP"
                        handleChange={handleChange}
                        Name="query"
                        value={payload?.searchText}
                        accsessablityId="headingColor"
                      />
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-3 mb-3">
                      <div className="tableinfo mt-2">
                        <button
                          class="btn blue-bg text-white mt-sm-2 mt-md-4 mt-lg-4 px-4"
                          type="button"
                          onClick={handleSearch}
                        >
                          {t("searchbutton")}
                        </button>
                      </div>
                    </div>


                    <div className="col-sm-12 col-md-12 col-lg-3 mb-2 ">
                      <div className="product-list d-flex justify-content-md-start justify-content-lg-end mt-sm-2 mt-md-2 mt-lg-4 mb-md-3 mb-lg-0">
                        <div class="dropdown">
                          <button className="border-0 pdfbutton text-light py-2 px-md-4 mt-2 px-2"> <img
                            src={DOWNLOAD_ICON}
                            alt=".."
                            className="img-fluid me-2"
                          /> Download Files</button>
                          <div class="dropdown-content">

                            <div className="cursor-pointer" onClick={downloadPdf}><img
                              src={INPUT_PDF_ICON}
                              alt=".."
                              width="20px"
                              className="img-fluid me-2"
                            /> Download PDF</div>

                            <div className="cursor-pointer">
                              <CSVLink filename={"Product List_" + datetime + '.csv'}
                                data={csvData} headers={csvheaders}>
                                <img
                                  src={INPUT_CSV_ICON}
                                  alt=".."
                                  width="20px"
                                  className="img-fluid me-2"
                                /> Download CSV</CSVLink>
                            </div>
                          </div>
                        </div>
                        {/* <button
                          className="border-0 pdfbutton text-light py-2 px-md-4 mt-2 px-2"
                          onClick={downloadPdf}
                        >

                          {
                            loaderbtn ? (<span className="spinner-border spinner-border-sm mx-1" name="spinner" role="status" aria-hidden="true"></span>) : <img
                              src={DOWNLOAD_ICON}
                              alt=".."
                              className="img-fluid me-2"
                            />

                          }
                          DOWNLOAD PDF
                        </button> */}
                        {" "}
                      </div>
                    </div>
                  </div>
                  <div><p className="red"><span className="fw-bold">Note:-</span>Zero MRP products are under process</p></div>
                  <div className="productportfolio">
                    {productsList?.length ? (
                      <AdminDataTable
                        selectedRows={selectedRows}
                        _tblColumns={tblColumns}
                        _rowData={productsList}
                        tableCustomStyles={tableCustomStyles}
                        setSortDirection={setSortDirection}
                        setPage={setPage}
                        setSortColumn={setSortColumn}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        _totalRows={totalElement}
                        pending={pending}
                        setPending={setPending}
                        setIsSearchTriggered={setIsSearch}
                      />
                    ) : (
                      <div className="mb-5">
                        <RecordNotfound />
                      </div>
                    )}
                  </div>
                </>
              )}
              {name === "ProductviewList" && (
                <>
                  <div className="row tabledropdown tableinfo">
                    <div className="col-sm-12 col-md-12 col-lg-6 mb-3">
                      <select class="inputText w-100 select-height" aria-label="Default select example" value={filterValue} onChange={handleViewListSelect}>
                        <option value="id">--Select Product Detail--</option>
                        <option value="mrp">MRP Lowest to Highest</option>
                        <option value="mrp_3">MRP Highest to Lowest</option>
                        <option value="group_name">Group wise</option>
                        <option value="drug_code">Drug Code wise</option>
                        <option value="generic_name">Generic Name wise</option>
                        <option value="unit_size">Unit Size wise</option>
                      </select>
                    </div>
                    {/* <div className="col-sm-12 col-md-12 col-lg-3 mb-3">
                      <div className="tableinfo">
                        <button
                          class="btn blue-bg text-white mt-sm-2 mt-md-4 mt-lg-4 px-4"
                          type="button"
                          onClick={handleSearch}
                        >
                          {t("searchbutton")}
                        </button>
                      </div>
                    </div> */}

                    <div className="col-sm-12 col-md-12 col-lg-6 mb-2 ">
                      <div className="product-list d-flex justify-content-md-start justify-content-lg-end mt-sm-2 mt-md-2 mb-md-3 mb-lg-0">
                        <div class="dropdown">
                          <button className="border-0 pdfbutton text-light py-2 px-md-4 px-2"> <img
                            src={DOWNLOAD_ICON}
                            alt=".."
                            className="img-fluid me-2"
                          /> Download Files</button>
                          <div class="dropdown-content">

                            <div className="cursor-pointer" onClick={downloadPdf}><img
                              src={INPUT_PDF_ICON}
                              alt=".."
                              width="20px"
                              className="img-fluid me-2"
                            /> Download PDF</div>

                            <div className="cursor-pointer">
                              <CSVLink filename={"Product List_" + datetime + '.csv'}
                                data={csvData} headers={csvheaders}>
                                <img
                                  src={INPUT_CSV_ICON}
                                  alt=".."
                                  width="20px"
                                  className="img-fluid me-2"
                                /> Download CSV</CSVLink>
                            </div>
                          </div>
                        </div>
                        {/* <button
                          className="border-0 pdfbutton text-light py-2 px-md-4 px-2"
                          onClick={downloadPdf}
                        >

                          {
                            loaderbtn ? (<span className="spinner-border spinner-border-sm mx-1" name="spinner" role="status" aria-hidden="true"></span>) : <img
                              src={DOWNLOAD_ICON}
                              alt=".."
                              className="img-fluid me-2"
                            />

                          }
                          DOWNLOAD PDF
                        </button> */}
                        {" "}
                      </div>
                    </div>
                  </div>
                  <div><p className="red"><span className="fw-bold">Note:-</span>Zero MRP products are under process</p></div>
                  <div className="productportfolio">
                    {productsList?.length ? (
                      <AdminDataTable
                        _tblColumns={tblColumns}
                        _rowData={productsList}
                        _totalRows={totalElementShortedList}
                        tableCustomStyles={tableCustomStyles}
                        setSortDirection={setSortDirection}
                        setPage={setPage}
                        setSortColumn={setSortColumn}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        pending={pending}
                        setPending={setPending}
                      />
                    ) : (
                      <div className="mb-5">
                        <RecordNotfound />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPortfolio;
